<template>
  <!-- 알림 팝업 -->
  <div class="pop-alert pop-alert-common">
      <div class="container">
          <div class="pop-header clearfix">
              <div class="f-left">알림</div>
              <div class="f-right">
                  <button type="button" class="pop-close" @click="closePopAlert();"><span class="blind">팝업닫기</span></button>
              </div>
          </div>
          <div class="pop-content">
              <p>
                  {{msg}}
              </p>
              <button type="button" class="pop-close" @click="onConfirmEvent();">확인</button>
          </div>
      </div>
  </div>
  <!--// 알림 팝업 -->
</template>
<script>

export default {
  props: ['postMessage','showPopup'],
  data(){
    return {
      msg:'',
      confirm:null
    }
  },
  created() {
    this.msg = this.postMessage;
  },
  watch: {
    showPopup: function(value) {
        if(value) this.openPopAlert()
        else this.closePopAlert();
    }
  },
  methods:{
    onConfirmEvent:function(e){
        this.closePopAlert()
        this.$emit('onConfirmEvent',this.confirm);     
        if(this.confirm) 
          this.confirm();
    },
    show(msg,confirm){
      // this.postMessage = msg;
      this.msg = msg
      if(confirm)this.confirm = confirm

      this.openPopAlert('alert-common');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/PopCommonAlert.vue